import { BuildingsIcon as PhosphorBuildingsIcon } from "@phosphor-icons/react/dist/ssr/Buildings";

import { createAppIcon } from "@/components/createAppIcon";

export const OrganizationIcon = /* @__PURE__ */ createAppIcon(PhosphorBuildingsIcon);
export const CompanyIcon = /* @__PURE__ */ createAppIcon(PhosphorBuildingsIcon);
export const CompanyUnavailableIcon = /* @__PURE__ */ createAppIcon(PhosphorBuildingsIcon);
